import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=93cfe594&scoped=true&"
import script from "./AdminChat.vue?vue&type=script&lang=js&"
export * from "./AdminChat.vue?vue&type=script&lang=js&"
import style0 from "./AdminChat.vue?vue&type=style&index=0&id=93cfe594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cfe594",
  null
  
)

export default component.exports